<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="800"
  >
    <v-card class="rounded_card">
      <v-card-title>取扱品目の追加</v-card-title>
      <v-card-text>
        <v-treeview
          ref="tree"
          v-model="handleItems"
          :items="items"
          :open.sync="parentItems"
          item-key="id"
          open-on-click
          selection-type="independent"
          selected-color="primary"
          selectable
        >
          <template v-slot:label="{ item }">
            {{ item.code }}: {{ item.name }}
          </template>
        </v-treeview>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">
          閉じる
        </v-btn>
        <v-btn
          color="primary"
          @click="registerButtonClickEvent"
        >
          登録
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: 'EmissionItemDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    emissionId: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      items: [],
      handleItems: [],
      parentItems: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newVal) {
      if (newVal) {
        this.fetchItems().then((content) => {
          this.items = content.items
          this.searchEmissionItems()
        })
      }
    }
  },
  created() {
  },
  methods: {
    ...mapActions('DriverMasterItem', {
      fetchItems: 'fetchAll'
    }),
    ...mapActions('DriverMasterEmissionItem', {
      fetchEmissionItem: 'edit',
      updateEmissionItems: 'update'
    }),
    closeButtonClickEvent() {
      this.$emit('closeEvent')
    },
    registerButtonClickEvent () {
      let params = { item_ids: this.handleItems }
      this.updateEmissionItems({ emission_id: this.emissionId, params:  params }).then(() => {
        this.$emit('registerEvent')
      })
    },
    searchEmissionItems () {
      this.fetchEmissionItem({ emission_id: this.emissionId }).then((content) => {
        this.parentItems = content.parent_items
        this.handleItems = content.items
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
